firebird.controller('changeBrowserCtrl', [
    '$stateParams',
    'logService',
    'helperService',
    function ($stateParams, logService, helperService) {
        var self = this;

        self.meetingLinkWithParam = '';

        init();

        ////////////////////////

        function init() {
            logService.log('init changeBrowserCtrl');

            var host = helperService.getLocationHost().toLowerCase();
            self.meetingLinkWithParam = host + '/' + $stateParams.meetingCode;
            self.meetingLinkWithParam += $stateParams.presenterGUID ? '?rslt=' + $stateParams.presenterGUID : '';
        }
    }
]);
